import { render, staticRenderFns } from "./Protected.vue?vue&type=template&id=1c070b01&"
import script from "./Protected.vue?vue&type=script&lang=ts&"
export * from "./Protected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports